export default __webpack_public_path__ + "static/media/logo-kaiko.04b2120a.png";